import { ReactNode } from 'react';
import { Check, AlertTriangle, XCircle, Info } from 'lucide-react';

interface Props {
  kind: 'ok' | 'warn' | 'err' | 'info';
  children: ReactNode;
}

const STYLES = {
  ok: { bg: 'rgba(22,163,74,0.08)', color: '#15803D', border: '#16A34A' },
  warn: { bg: 'rgba(217,119,6,0.08)', color: '#9A6113', border: '#D97706' },
  err: { bg: 'rgba(220,38,38,0.08)', color: '#9F1B1B', border: '#DC2626' },
  info: { bg: 'rgba(37,99,235,0.08)', color: '#1D4ED8', border: '#2563EB' },
} as const;

export function Alert({ kind, children }: Props) {
  const s = STYLES[kind];
  const Icon =
    kind === 'ok' ? Check : kind === 'warn' ? AlertTriangle : kind === 'info' ? Info : XCircle;
  return (
    <div
      role={kind === 'err' ? 'alert' : 'status'}
      aria-live={kind === 'err' ? 'assertive' : 'polite'}
      className="flex items-start gap-2 px-3 py-2.5 rounded-lg text-xs leading-relaxed mt-2"
      style={{ background: s.bg, color: s.color, borderLeft: `3px solid ${s.border}` }}
    >
      <Icon size={14} strokeWidth={2.5} className="flex-shrink-0 mt-0.5" />
      <span>{children}</span>
    </div>
  );
}
